import Axios from 'axios'
import configUrl from './configUrl'

const api = Axios.create({
    baseURL:`${configUrl.protocol}://${configUrl.ip}/v1`,
    timeout: 25000,
})

api.interceptors.request.use(async config => {
    const token = localStorage.getItem('@oee-monitor/token');
    if (token) {
        config.headers.Authorization =`Bearer ${token}`;
    }
    return config;
})

export default api;